// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Desktop layout (matches extensions_section style) ── */

.deploy_section {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    background: var(--color-bg);
    color: var(--color-text);
}

.deploy_section__header {
    padding: 10px 16px 0;
    border-bottom: 1px solid var(--color-border);
    flex-shrink: 0;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
}

.deploy_section__tabs {
    display: flex;
    gap: 2px;
    margin-bottom: -1px;
}

.deploy_section__configure_btn {
    padding: 4px 10px;
    margin-bottom: 6px;
    font-size: 12px;
    border-radius: 3px;
    border: 1px solid var(--color-border);
    background: var(--color-bg-3);
    color: var(--color-text-muted);
    cursor: pointer;
    transition: color 0.1s, background-color 0.1s;
    flex-shrink: 0;
}

@media (pointer: fine) {
    .deploy_section__configure_btn:hover {
        color: var(--color-text);
        background-color: var(--color-border);
    }
}

.deploy_section__tab {
    padding: 6px 16px;
    background: none;
    border: 1px solid transparent;
    border-bottom: none;
    color: var(--color-text-muted);
    cursor: pointer;
    font-size: 13px;
    border-radius: 4px 4px 0 0;
    transition: color 0.1s;
}

@media (pointer: fine) {
    .deploy_section__tab:hover {
        color: var(--color-text);
    }
}

.deploy_section__tab.active {
    color: var(--color-text);
    background: var(--color-bg-2);
    border-color: var(--color-border);
}

/* Toolbar row: env select + search */

.deploy_section__toolbar {
    padding: 10px 16px;
    flex-shrink: 0;
    background: var(--color-bg);
    border-bottom: 1px solid var(--color-border);
    display: flex;
    gap: 8px;
    align-items: center;
}

.deploy_section__toolbar--inline {
    padding: 0 0 10px;
    border-bottom: none;
    background: none;
}

.deploy_section__toolbar--accordion {
    position: sticky;
    top: 0;
    z-index: 1;
}

.deploy_section__env_select {
    flex: 0 0 auto;
    min-width: 100px;
}

.deploy_section__search_input {
    flex: 1;
    min-width: 0;
    background: var(--color-input-bg, rgba(255,255,255,0.06));
    border: 1px solid var(--color-input-border, var(--color-border));
    color: var(--color-text);
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 13px;
    outline: none;
    box-sizing: border-box;
}

.deploy_section__search_input::placeholder {
    color: var(--color-text-muted);
}

.deploy_section__search_input:focus {
    border-color: var(--color-input-border-focus, var(--color-accent));
}

/* Body — fills remaining space */

.deploy_section__body {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    position: relative;
}

.deploy_section__body--padded {
    overflow-y: auto;
    padding: 16px;
    box-sizing: border-box;
}

/* Services scrollable area */

.deploy_section__services_scroll {
    height: 100%;
    overflow-y: auto;
    padding: 14px 16px;
    box-sizing: border-box;
}

/* ── Service cards (like extension cards) ── */

.deploy_section__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 10px;
}

.deploy_section__card {
    background: var(--color-bg-2);
    border: 1px solid var(--color-border);
    border-radius: 6px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    transition: border-color 0.15s;
}

@media (pointer: fine) {
    .deploy_section__card:hover {
        border-color: var(--color-accent);
    }
}

.deploy_section__card_header {
    display: flex;
    align-items: center;
    gap: 10px;
}

.deploy_section__card_icon_placeholder {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    background: var(--color-bg-3, rgba(255,255,255,0.06));
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-text-muted);
}

.deploy_section__card_meta {
    flex: 1;
    min-width: 0;
}

.deploy_section__card_name {
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--color-text);
}

.deploy_section__card_env {
    font-size: 11px;
    color: var(--color-text-muted);
    margin-top: 1px;
}

.deploy_section__card_status_badge {
    font-size: 11px;
    padding: 2px 7px;
    border-radius: 4px;
    font-weight: 500;
    flex-shrink: 0;
    background: var(--color-bg-3, rgba(255,255,255,0.06));
    color: var(--color-text-muted);
}

.deploy_section__card_status--running,
.deploy_section__card_status--up {
    background: rgba(34, 197, 94, 0.15);
    color: #22c55e;
}

.deploy_section__card_status--stopped,
.deploy_section__card_status--exited,
.deploy_section__card_status--down {
    background: rgba(239, 68, 68, 0.15);
    color: #ef4444;
}

.deploy_section__card_status--starting,
.deploy_section__card_status--restarting {
    background: rgba(234, 179, 8, 0.15);
    color: #eab308;
}

.deploy_section__card_footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    margin-top: auto;
    padding-top: 4px;
}

.deploy_section__card_btn {
    padding: 4px 10px;
    background: none;
    border: 1px solid var(--color-border);
    color: var(--color-text-muted);
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    white-space: nowrap;
    transition: border-color 0.1s, color 0.1s;
}

@media (pointer: fine) {
    .deploy_section__card_btn:hover {
        border-color: var(--color-text-muted);
        color: var(--color-text);
    }
}

.deploy_section__card_btn--deploy {
    background: var(--color-accent, #4a6cf7);
    border-color: var(--color-accent, #4a6cf7);
    color: #fff;
}

@media (pointer: fine) {
    .deploy_section__card_btn--deploy:hover {
        opacity: 0.85;
        color: #fff;
    }
}

.deploy_section__card_btn--terminal {
    padding: 4px 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

/* ── Bottom log pane ── */

.deploy_section__log_pane {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-top: 1px solid var(--color-border);
}

.deploy_section__log_pane_tabs {
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    background: var(--color-bg-2);
    border-bottom: 1px solid var(--color-border);
    overflow-x: auto;
    scrollbar-width: none;
}

.deploy_section__log_pane_tabs::-webkit-scrollbar {
    display: none;
}

.deploy_section__log_pane_body {
    position: relative;
    flex: 1;
    overflow: hidden;
}

.deploy_section__log_modifiers {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 18px;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 8px;
    gap: 1px;
    pointer-events: none;
}

.deploy_section__log_modifier_btn {
    pointer-events: auto;
    width: 18px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    line-height: 1;
    cursor: pointer;
    color: var(--color-terminal-text);
    opacity: 0.6;
    border-radius: 2px;
    border: none;
    background: none;
    padding: 0;
    transition: color 0.12s, background-color 0.12s;
    user-select: none;
}

@media (pointer: fine) {
    .deploy_section__log_modifier_btn:hover {
        color: var(--color-terminal-text);
        opacity: 1;
        background-color: rgba(255, 255, 255, 0.1);
    }
}

.deploy_section__log_modifier_btn--active {
    color: var(--color-accent, #3498db);
}

.deploy_section__log_pane_tab {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding: 0 12px;
    height: 34px;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    color: var(--color-text-muted);
    font-size: 12px;
    cursor: pointer;
    white-space: nowrap;
    user-select: none;
    transition: color 0.1s, border-color 0.1s;
    gap: 6px;
}

@media (pointer: fine) {
    .deploy_section__log_pane_tab:hover {
        color: var(--color-text);
        background: var(--color-bg-3, rgba(255,255,255,0.04));
    }
}

.deploy_section__log_pane_tab.active {
    color: var(--color-text);
    border-bottom-color: var(--color-accent, #4a6cf7);
}

.deploy_section__log_pane_tab_label {
    flex: 1;
}

.deploy_section__log_pane_tab_close {
    width: 14px;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    font-size: 15px;
    line-height: 1;
    opacity: 0.6;
    transition: opacity 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .deploy_section__log_pane_tab_close:hover {
        opacity: 1 !important;
        background-color: var(--color-bg-3, rgba(255,255,255,0.08));
    }
}

.deploy_section__log_pane_viewport {
    position: absolute;
    inset: 0;
    background: var(--color-terminal-bg);
}

/* Virtuoso scroller root. Vertical padding comes from its Header/Footer
   spacers; overflow-y is set inline by Virtuoso. */
.deploy_section__log_pane_content {
    height: 100%;
    overflow-x: auto;
    padding: 0 12px 0 24px;
    scrollbar-width: thin;
    box-sizing: border-box;
}

.deploy_section__log_pane_empty {
    font-size: 12px;
    color: var(--color-terminal-text);
    opacity: 0.6;
    padding: 8px 0;
}

/* ── Shared: log lines ── */

.deploy_section__log_line {
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: inherit;
    line-height: 1.6;
    color: var(--color-terminal-text);
    white-space: pre;
    /* Grow past the viewport so wide TUI output scrolls horizontally, but
       still fill it so short lines span the full row. */
    width: max-content;
    min-width: 100%;
}

.deploy_section__log_pane_content--wrap .deploy_section__log_line {
    white-space: pre-wrap;
    word-break: break-all;
    width: auto;
    min-width: 0;
}

.deploy_section__log_line--cursor {
    color: var(--color-accent, #4a6cf7);
    animation: deploy_cursor_blink 1s step-end infinite;
}

@keyframes deploy_cursor_blink {
    0%, 100% { opacity: 1; }
    50%       { opacity: 0; }
}

/* ── Error banner ── */

.deploy_section__error_banner {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 24px 16px;
    padding: 14px 16px;
    border-radius: 6px;
    background: color-mix(in srgb, var(--color-danger, #e53e3e) 10%, transparent);
    border: 1px solid color-mix(in srgb, var(--color-danger, #e53e3e) 35%, transparent);
    color: var(--color-danger, #e53e3e);
    font-size: 13px;
    font-family: monospace;
    line-height: 1.6;
    word-break: break-all;
}

.deploy_section__error_banner--clickable {
    cursor: pointer;
    user-select: none;
}

.deploy_section__error_banner--clickable:hover {
    background: color-mix(in srgb, var(--color-danger, #e53e3e) 15%, transparent);
}

.deploy_section__error_banner_body {
    flex: 1;
    min-width: 0;
}

.deploy_section__error_banner_summary {
    white-space: pre-wrap;
}

.deploy_section__error_banner_toggle {
    opacity: 0.7;
    font-size: 11px;
}

.deploy_section__error_banner_detail {
    margin: 10px 0 0;
    padding: 10px;
    background: color-mix(in srgb, var(--color-danger, #e53e3e) 8%, transparent);
    border-radius: 4px;
    font-size: 12px;
    white-space: pre-wrap;
    word-break: break-all;
    overflow-x: auto;
}

.deploy_section__error_banner_icon {
    flex-shrink: 0;
    font-size: 15px;
    font-family: sans-serif;
    margin-top: 1px;
}

/* ── Empty state ── */

.deploy_section__empty {
    text-align: center;
    color: var(--color-text-muted);
    padding: 48px 0;
    font-size: 14px;
}

/* ── Mobile layout ── */

/* Mobile uses the same flex-column tab layout as desktop — no overrides needed
   beyond cosmetic tweaks like smaller tab hit areas on narrow screens. */
.deploy_section--mobile .deploy_section__tab {
    padding: 6px 12px;
}

.deploy_section__tab_content {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

/* Accordion section: padding inside each accordion item */
.deploy_section__accordion_section {
    padding: 12px 4px;
}

/* Mobile log pane inside accordion: fill the accordion content area */
.deploy_section__log_pane--accordion {
    height: 100%;
    border-top: none;
}

/* Mobile env tabs */

.deploy_section__env_tabs {
    display: flex;
    gap: 4px;
}

.deploy_section__env_tab {
    padding: 5px 14px;
    border-radius: 6px;
    border: 1px solid var(--color-border, #333);
    background: transparent;
    color: var(--color-text-muted);
    font-size: 13px;
    cursor: pointer;
    transition: background 0.1s, color 0.1s;
}

@media (pointer: fine) {
    .deploy_section__env_tab:hover {
        background: var(--color-bg-hover, rgba(255,255,255,0.06));
        color: var(--color-text, #fff);
    }
}

.deploy_section__env_tab.active {
    background: var(--color-accent, #4a6cf7);
    border-color: var(--color-accent, #4a6cf7);
    color: #fff;
}

/* Mobile service list */

.deploy_section__service_list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.deploy_section__service_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    border-radius: 8px;
    background: var(--color-bg-secondary, rgba(255,255,255,0.04));
    border: 1px solid var(--color-border, #333);
}

.deploy_section__service_name {
    font-size: 13px;
    color: var(--color-text, #fff);
}

.deploy_section__service_status {
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 500;
    background: var(--color-bg-hover, rgba(255,255,255,0.08));
    color: var(--color-text-muted);
}

.deploy_section__service_status--running,
.deploy_section__service_status--up {
    background: rgba(34, 197, 94, 0.15);
    color: #22c55e;
}

.deploy_section__service_status--stopped,
.deploy_section__service_status--exited,
.deploy_section__service_status--down {
    background: rgba(239, 68, 68, 0.15);
    color: #ef4444;
}

.deploy_section__service_status--starting,
.deploy_section__service_status--restarting {
    background: rgba(234, 179, 8, 0.15);
    color: #eab308;
}

/* Mobile deploy buttons */

.deploy_section__deploy_btns {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.deploy_section__deploy_btn {
    padding: 7px 18px;
    border-radius: 6px;
    border: 1px solid var(--color-accent, #4a6cf7);
    background: var(--color-accent, #4a6cf7);
    color: #fff;
    font-size: 13px;
    cursor: pointer;
    transition: opacity 0.1s;
}

@media (pointer: fine) {
    .deploy_section__deploy_btn:hover:not(:disabled) {
        opacity: 0.85;
    }
}

.deploy_section__deploy_btn:disabled {
    opacity: 0.4;
    cursor: default;
}

.deploy_section__deploy_btn--running {
    opacity: 0.7;
}

/* Mobile custom service row */

.deploy_section__custom_row {
    display: flex;
    gap: 8px;
}

.deploy_section__custom_input {
    flex: 1;
    padding: 7px 12px;
    border-radius: 6px;
    border: 1px solid var(--color-border, #333);
    background: var(--color-bg-secondary, rgba(255,255,255,0.04));
    color: var(--color-text, #fff);
    font-size: 13px;
    outline: none;
    transition: border-color 0.1s;
}

.deploy_section__custom_input:focus {
    border-color: var(--color-accent, #4a6cf7);
}

.deploy_section__custom_input::placeholder {
    color: var(--color-text-muted);
}

/* Mobile proxy row */

.deploy_section__proxy_row {
    display: flex;
    gap: 8px;
}

.deploy_section__proxy_port_input {
    flex: 1;
    padding: 7px 12px;
    border-radius: 6px;
    border: 1px solid var(--color-border, #333);
    background: var(--color-bg-secondary, rgba(255,255,255,0.04));
    color: var(--color-text, #fff);
    font-size: 13px;
    outline: none;
    transition: border-color 0.1s;
}

.deploy_section__proxy_port_input:focus {
    border-color: var(--color-accent, #4a6cf7);
}

.deploy_section__proxy_port_input::placeholder {
    color: var(--color-text-muted);
}

/* Sessions list */

.deploy_section__sessions {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.deploy_section__session_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 7px 10px;
    border-radius: 6px;
    border: 1px solid var(--color-border, #333);
    background: var(--color-bg-secondary, rgba(255,255,255,0.04));
}

.deploy_section__session_label {
    font-size: 12px;
    color: var(--color-text-muted);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
}

.deploy_section__session_loading {
    font-size: 11px;
    color: var(--color-text-muted);
    flex-shrink: 0;
}

.deploy_section__session_actions {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
}

.deploy_section__session_btn {
    padding: 3px 10px;
    border-radius: 4px;
    border: 1px solid var(--color-border, #333);
    background: transparent;
    color: var(--color-text-muted);
    font-size: 11px;
    cursor: pointer;
    transition: color 0.1s, border-color 0.1s;
}

@media (pointer: fine) {
    .deploy_section__session_btn:hover {
        color: var(--color-text);
        border-color: var(--color-accent, #4a6cf7);
    }
}

.deploy_section__session_btn--close {
    padding: 3px 7px;
}

/* Mobile log panel */

.deploy_section__log_panel {
    display: flex;
    flex-direction: column;
    gap: 6px;
    border: 1px solid var(--color-border, #333);
    border-radius: 6px;
    overflow: hidden;
}

.deploy_section__log_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 7px 12px;
    background: var(--color-bg, #1a1a1a);
    border-bottom: 1px solid var(--color-border, #333);
}

.deploy_section__log_title {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--color-text-muted);
}

.deploy_section__log_clear {
    background: none;
    border: none;
    font-size: 11px;
    color: var(--color-text-muted);
    cursor: pointer;
    padding: 0 4px;
    opacity: 0.7;
    transition: opacity 0.1s;
}

@media (pointer: fine) {
    .deploy_section__log_clear:hover {
        opacity: 1;
    }
}

.deploy_section__log_stop {
    background: none;
    border: 1px solid var(--color-danger, #e53e3e);
    border-radius: 3px;
    font-size: 11px;
    color: var(--color-danger, #e53e3e);
    cursor: pointer;
    padding: 1px 6px;
    opacity: 0.85;
    transition: opacity 0.1s;
}

@media (pointer: fine) {
    .deploy_section__log_stop:hover {
        opacity: 1;
    }
}

.deploy_section__log_body {
    max-height: 280px;
    overflow-y: auto;
    padding: 8px 12px;
    background: var(--color-bg-2, #111);
    scrollbar-width: thin;
}

/* ── Desktop inline browser tab panel ── */

.deploy_section__browser_panel {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}

.deploy_section__browser_tabs_bar {
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    background-color: var(--color-bg-2);
    border-bottom: 1px solid var(--color-border);
    overflow-x: auto;
    scrollbar-width: none;
    touch-action: pan-x;
}

.deploy_section__browser_tabs_bar::-webkit-scrollbar {
    display: none;
}

.deploy_section__browser_tab {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding: 0 18px;
    height: 38px;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    color: var(--color-text-muted);
    font-size: 13px;
    cursor: pointer;
    white-space: nowrap;
    user-select: none;
    gap: 7px;
    transition: color 0.1s, border-color 0.1s;
}

@media (pointer: fine) {
    .deploy_section__browser_tab:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

.deploy_section__browser_tab.active {
    color: var(--color-text);
    border-bottom-color: var(--color-accent);
}

.deploy_section__browser_tab_label {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 140px;
}

.deploy_section__browser_tab_close {
    flex-shrink: 0;
    width: 15px;
    height: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    font-size: 15px;
    line-height: 1;
    opacity: 0;
    transition: opacity 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .deploy_section__browser_tab:hover .deploy_section__browser_tab_close,
    .deploy_section__browser_tab.active .deploy_section__browser_tab_close {
        opacity: 0.6;
    }

    .deploy_section__browser_tab_close:hover {
        opacity: 1 !important;
        background-color: var(--color-bg-3);
    }
}

@media (pointer: coarse) {
    .deploy_section__browser_tab_close {
        opacity: 0.7;
    }
}

.deploy_section__browser_new_tab_btn {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    background: none;
    border: none;
    color: var(--color-text-muted);
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    transition: color 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .deploy_section__browser_new_tab_btn:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

/* Relative container so BrowserStreamModal (position:absolute) fills this area */
.deploy_section__browser_content {
    position: relative;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.deploy_section__browser_empty {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

/* ── Desktop inline terminal tab panel ── */

.deploy_section__terminal_panel {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}

.deploy_section__terminal_tabs_bar {
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    background-color: var(--color-bg-2);
    border-bottom: 1px solid var(--color-border);
    overflow-x: auto;
    scrollbar-width: none;
    touch-action: pan-x;
}

.deploy_section__terminal_tabs_bar::-webkit-scrollbar {
    display: none;
}

.deploy_section__terminal_tab {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding: 0 18px;
    height: 38px;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    color: var(--color-text-muted);
    font-size: 13px;
    cursor: pointer;
    white-space: nowrap;
    user-select: none;
    gap: 7px;
    transition: color 0.1s, border-color 0.1s;
}

@media (pointer: fine) {
    .deploy_section__terminal_tab:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

.deploy_section__terminal_tab.active {
    color: var(--color-text);
    border-bottom-color: var(--color-accent);
}

.deploy_section__terminal_tab_label {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 140px;
}

.deploy_section__terminal_tab_close {
    flex-shrink: 0;
    width: 15px;
    height: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    font-size: 15px;
    line-height: 1;
    opacity: 0;
    transition: opacity 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .deploy_section__terminal_tab:hover .deploy_section__terminal_tab_close,
    .deploy_section__terminal_tab.active .deploy_section__terminal_tab_close {
        opacity: 0.6;
    }

    .deploy_section__terminal_tab_close:hover {
        opacity: 1 !important;
        background-color: var(--color-bg-3);
    }
}

@media (pointer: coarse) {
    .deploy_section__terminal_tab_close {
        opacity: 0.7;
    }
}

.deploy_section__terminal_new_tab_btn {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    background: none;
    border: none;
    color: var(--color-text-muted);
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    transition: color 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .deploy_section__terminal_new_tab_btn:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

.deploy_section__terminal_new_tab_wrapper {
    position: relative;
    flex-shrink: 0;
}

.deploy_section__terminal_new_selector {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 100;
    min-width: 160px;
    background: var(--color-bg-2, #1a1a2e);
    border: 1px solid var(--color-border);
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.deploy_section__terminal_new_selector_title {
    padding: 6px 12px;
    font-size: 11px;
    color: var(--color-text-muted);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-bottom: 1px solid var(--color-border);
}

.deploy_section__terminal_new_selector_item {
    background: none;
    border: none;
    text-align: left;
    padding: 8px 12px;
    font-size: 13px;
    color: var(--color-text);
    cursor: pointer;
    transition: background-color 0.1s;
}

@media (pointer: fine) {
    .deploy_section__terminal_new_selector_item:hover {
        background-color: var(--color-bg-3);
    }
}

/* Relative container so TerminalModal (position:absolute) fills this area */
.deploy_section__terminal_content {
    position: relative;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.deploy_section__terminal_empty {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

/* ── New Terminal Modal ──────────────────────────────────────────────────── */

.deploy_section__new_terminal_modal_backdrop {
    position: fixed;
    inset: 0;
    z-index: 1100;
    background: rgba(0, 0, 0, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
}

.deploy_section__new_terminal_modal {
    background: var(--color-bg-2, #1a1a2e);
    border: 1px solid var(--color-border);
    border-radius: 10px;
    padding: 20px;
    min-width: 300px;
    max-width: 440px;
    width: 90%;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.deploy_section__new_terminal_modal_title {
    font-size: 15px;
    font-weight: 600;
    color: var(--color-text);
}

.deploy_section__new_terminal_modal_section {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.deploy_section__new_terminal_modal_label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--color-text-muted);
}

.deploy_section__new_terminal_modal_services {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-height: 200px;
    overflow-y: auto;
}

.deploy_section__new_terminal_modal_service {
    background: none;
    border: 1px solid var(--color-border);
    border-radius: 6px;
    text-align: left;
    padding: 8px 12px;
    font-size: 13px;
    color: var(--color-text-muted);
    cursor: pointer;
    transition: background 0.1s, color 0.1s, border-color 0.1s;
}

@media (pointer: fine) {
    .deploy_section__new_terminal_modal_service:hover {
        background: var(--color-bg-hover, rgba(255,255,255,0.06));
        color: var(--color-text);
    }
}

.deploy_section__new_terminal_modal_service.active {
    background: var(--color-accent, #4a6cf7);
    border-color: var(--color-accent, #4a6cf7);
    color: #fff;
}

.deploy_section__new_terminal_modal_actions {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
}

.deploy_section__new_terminal_modal_cancel {
    padding: 7px 18px;
    border-radius: 6px;
    border: 1px solid var(--color-border);
    background: transparent;
    color: var(--color-text-muted);
    font-size: 13px;
    cursor: pointer;
    transition: background 0.1s, color 0.1s;
}

@media (pointer: fine) {
    .deploy_section__new_terminal_modal_cancel:hover {
        background: var(--color-bg-hover, rgba(255,255,255,0.06));
        color: var(--color-text);
    }
}

/* ── Mobile inline override ──────────────────────────────────────────────────
   On pointer:coarse (touch), .proxy_modal and .terminal_modal default to
   position:fixed (full viewport). Override to position:absolute so they fill
   the inline container instead. Scoped tightly — only inside our containers.
   To restore old mobile floating behavior: remove these two rules.            */

@media (pointer: coarse) {
    .deploy_section__browser_content .proxy_modal {
        position: absolute;
    }

    .deploy_section__terminal_content .terminal_modal {
        position: absolute;
    }
}

`, "",{"version":3,"sources":["webpack://./components/sections/DeploymentSection/s.deploy_section.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;IACpB,4CAA4C;IAC5C,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,qCAAqC;IACrC,6BAA6B;IAC7B,8BAA8B;IAC9B,eAAe;IACf,6CAA6C;IAC7C,cAAc;AAClB;;AAEA;IACI;QACI,wBAAwB;QACxB,qCAAqC;IACzC;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,iCAAiC;AACrC;;AAEA,qCAAqC;;AAErC;IACI,kBAAkB;IAClB,cAAc;IACd,2BAA2B;IAC3B,4CAA4C;IAC5C,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,yDAAyD;IACzD,gEAAgE;IAChE,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kEAAkE;AACtE;;AAEA,iCAAiC;;AAEjC;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA,6BAA6B;;AAE7B;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,+CAA+C;;AAE/C;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,8BAA8B;AAClC;;AAEA;IACI;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qDAAqD;IACrD,8BAA8B;AAClC;;AAEA;;IAEI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;;;IAGI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;;IAEI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI;QACI,qCAAqC;QACrC,wBAAwB;IAC5B;AACJ;;AAEA;IACI,wCAAwC;IACxC,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI;QACI,aAAa;QACb,WAAW;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,0BAA0B;;AAE1B;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,6BAA6B;IAC7B,4CAA4C;IAC5C,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,eAAe;IACf,iCAAiC;IACjC,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,+CAA+C;IAC/C,iBAAiB;AACrB;;AAEA;IACI;QACI,iCAAiC;QACjC,UAAU;QACV,0CAA0C;IAC9C;AACJ;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,yCAAyC;IACzC,QAAQ;AACZ;;AAEA;IACI;QACI,wBAAwB;QACxB,qDAAqD;IACzD;AACJ;;AAEA;IACI,wBAAwB;IACxB,iDAAiD;AACrD;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI;QACI,qBAAqB;QACrB,2DAA2D;IAC/D;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,oCAAoC;AACxC;;AAEA;mDACmD;AACnD;IACI,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,YAAY;IACZ,cAAc;AAClB;;AAEA,4BAA4B;;AAE5B;IACI,4DAA4D;IAC5D,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,gBAAgB;IAChB;wDACoD;IACpD,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,mDAAmD;AACvD;;AAEA;IACI,WAAW,UAAU,EAAE;IACvB,YAAY,UAAU,EAAE;AAC5B;;AAEA,uBAAuB;;AAEvB;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,6EAA6E;IAC7E,mFAAmF;IACnF,mCAAmC;IACnC,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,6EAA6E;AACjF;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,4EAA4E;IAC5E,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,eAAe;AACnB;;AAEA,sBAAsB;;AAEtB;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;IACf,eAAe;AACnB;;AAEA,wBAAwB;;AAExB;yEACyE;AACzE;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,0DAA0D;AAC1D;IACI,iBAAiB;AACrB;;AAEA,sEAAsE;AACtE;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA,oBAAoB;;AAEpB;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,uBAAuB;IACvB,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI;QACI,yDAAyD;QACzD,8BAA8B;IAClC;AACJ;;AAEA;IACI,wCAAwC;IACxC,0CAA0C;IAC1C,WAAW;AACf;;AAEA,wBAAwB;;AAExB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,6DAA6D;IAC7D,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yDAAyD;IACzD,8BAA8B;AAClC;;AAEA;;IAEI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;;;IAGI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;;IAEI,mCAAmC;IACnC,cAAc;AAClB;;AAEA,0BAA0B;;AAE1B;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8CAA8C;IAC9C,wCAAwC;IACxC,WAAW;IACX,eAAe;IACf,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA,8BAA8B;;AAE9B;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,6DAA6D;IAC7D,8BAA8B;IAC9B,eAAe;IACf,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA,qBAAqB;;AAErB;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,6DAA6D;IAC7D,8BAA8B;IAC9B,eAAe;IACf,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8BAA8B;AAClC;;AAEA,kBAAkB;;AAElB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,6DAA6D;AACjE;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,uBAAuB;IACvB,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI;QACI,wBAAwB;QACxB,0CAA0C;IAC9C;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA,qBAAqB;;AAErB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,oCAAoC;IACpC,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,cAAc;IACd,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,8CAA8C;IAC9C,kBAAkB;IAClB,eAAe;IACf,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA,2CAA2C;;AAE3C;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mCAAmC;IACnC,4CAA4C;IAC5C,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,QAAQ;IACR,yCAAyC;AAC7C;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA;IACI,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,UAAU;IACV,+CAA+C;AACnD;;AAEA;IACI;;QAEI,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,mCAAmC;IACvC;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,cAAc;IACd,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA,iFAAiF;AACjF;IACI,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA,4CAA4C;;AAE5C;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mCAAmC;IACnC,4CAA4C;IAC5C,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,QAAQ;IACR,yCAAyC;AAC7C;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA;IACI,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,UAAU;IACV,+CAA+C;AACnD;;AAEA;IACI;;QAEI,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,mCAAmC;IACvC;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,cAAc;IACd,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,sCAAsC;IACtC,qCAAqC;IACrC,kBAAkB;IAClB,sCAAsC;IACtC,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,8BAA8B;IAC9B,yBAAyB;IACzB,sBAAsB;IACtB,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,wBAAwB;IACxB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI;QACI,mCAAmC;IACvC;AACJ;;AAEA,4EAA4E;AAC5E;IACI,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA,+EAA+E;;AAE/E;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,0DAA0D;AAC9D;;AAEA;IACI;QACI,yDAAyD;QACzD,wBAAwB;IAC5B;AACJ;;AAEA;IACI,wCAAwC;IACxC,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,uBAAuB;IACvB,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI;QACI,yDAAyD;QACzD,wBAAwB;IAC5B;AACJ;;AAEA;;;;gFAIgF;;AAEhF;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* ── Desktop layout (matches extensions_section style) ── */\n\n.deploy_section {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    overflow: hidden;\n    background: var(--color-bg);\n    color: var(--color-text);\n}\n\n.deploy_section__header {\n    padding: 10px 16px 0;\n    border-bottom: 1px solid var(--color-border);\n    flex-shrink: 0;\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n}\n\n.deploy_section__tabs {\n    display: flex;\n    gap: 2px;\n    margin-bottom: -1px;\n}\n\n.deploy_section__configure_btn {\n    padding: 4px 10px;\n    margin-bottom: 6px;\n    font-size: 12px;\n    border-radius: 3px;\n    border: 1px solid var(--color-border);\n    background: var(--color-bg-3);\n    color: var(--color-text-muted);\n    cursor: pointer;\n    transition: color 0.1s, background-color 0.1s;\n    flex-shrink: 0;\n}\n\n@media (pointer: fine) {\n    .deploy_section__configure_btn:hover {\n        color: var(--color-text);\n        background-color: var(--color-border);\n    }\n}\n\n.deploy_section__tab {\n    padding: 6px 16px;\n    background: none;\n    border: 1px solid transparent;\n    border-bottom: none;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    font-size: 13px;\n    border-radius: 4px 4px 0 0;\n    transition: color 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__tab:hover {\n        color: var(--color-text);\n    }\n}\n\n.deploy_section__tab.active {\n    color: var(--color-text);\n    background: var(--color-bg-2);\n    border-color: var(--color-border);\n}\n\n/* Toolbar row: env select + search */\n\n.deploy_section__toolbar {\n    padding: 10px 16px;\n    flex-shrink: 0;\n    background: var(--color-bg);\n    border-bottom: 1px solid var(--color-border);\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.deploy_section__toolbar--inline {\n    padding: 0 0 10px;\n    border-bottom: none;\n    background: none;\n}\n\n.deploy_section__toolbar--accordion {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n}\n\n.deploy_section__env_select {\n    flex: 0 0 auto;\n    min-width: 100px;\n}\n\n.deploy_section__search_input {\n    flex: 1;\n    min-width: 0;\n    background: var(--color-input-bg, rgba(255,255,255,0.06));\n    border: 1px solid var(--color-input-border, var(--color-border));\n    color: var(--color-text);\n    padding: 6px 10px;\n    border-radius: 4px;\n    font-size: 13px;\n    outline: none;\n    box-sizing: border-box;\n}\n\n.deploy_section__search_input::placeholder {\n    color: var(--color-text-muted);\n}\n\n.deploy_section__search_input:focus {\n    border-color: var(--color-input-border-focus, var(--color-accent));\n}\n\n/* Body — fills remaining space */\n\n.deploy_section__body {\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n    position: relative;\n}\n\n.deploy_section__body--padded {\n    overflow-y: auto;\n    padding: 16px;\n    box-sizing: border-box;\n}\n\n/* Services scrollable area */\n\n.deploy_section__services_scroll {\n    height: 100%;\n    overflow-y: auto;\n    padding: 14px 16px;\n    box-sizing: border-box;\n}\n\n/* ── Service cards (like extension cards) ── */\n\n.deploy_section__grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 10px;\n}\n\n.deploy_section__card {\n    background: var(--color-bg-2);\n    border: 1px solid var(--color-border);\n    border-radius: 6px;\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    transition: border-color 0.15s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__card:hover {\n        border-color: var(--color-accent);\n    }\n}\n\n.deploy_section__card_header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.deploy_section__card_icon_placeholder {\n    width: 40px;\n    height: 40px;\n    border-radius: 4px;\n    background: var(--color-bg-3, rgba(255,255,255,0.06));\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--color-text-muted);\n}\n\n.deploy_section__card_meta {\n    flex: 1;\n    min-width: 0;\n}\n\n.deploy_section__card_name {\n    font-size: 13px;\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: var(--color-text);\n}\n\n.deploy_section__card_env {\n    font-size: 11px;\n    color: var(--color-text-muted);\n    margin-top: 1px;\n}\n\n.deploy_section__card_status_badge {\n    font-size: 11px;\n    padding: 2px 7px;\n    border-radius: 4px;\n    font-weight: 500;\n    flex-shrink: 0;\n    background: var(--color-bg-3, rgba(255,255,255,0.06));\n    color: var(--color-text-muted);\n}\n\n.deploy_section__card_status--running,\n.deploy_section__card_status--up {\n    background: rgba(34, 197, 94, 0.15);\n    color: #22c55e;\n}\n\n.deploy_section__card_status--stopped,\n.deploy_section__card_status--exited,\n.deploy_section__card_status--down {\n    background: rgba(239, 68, 68, 0.15);\n    color: #ef4444;\n}\n\n.deploy_section__card_status--starting,\n.deploy_section__card_status--restarting {\n    background: rgba(234, 179, 8, 0.15);\n    color: #eab308;\n}\n\n.deploy_section__card_footer {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 6px;\n    margin-top: auto;\n    padding-top: 4px;\n}\n\n.deploy_section__card_btn {\n    padding: 4px 10px;\n    background: none;\n    border: 1px solid var(--color-border);\n    color: var(--color-text-muted);\n    border-radius: 4px;\n    font-size: 12px;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: border-color 0.1s, color 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__card_btn:hover {\n        border-color: var(--color-text-muted);\n        color: var(--color-text);\n    }\n}\n\n.deploy_section__card_btn--deploy {\n    background: var(--color-accent, #4a6cf7);\n    border-color: var(--color-accent, #4a6cf7);\n    color: #fff;\n}\n\n@media (pointer: fine) {\n    .deploy_section__card_btn--deploy:hover {\n        opacity: 0.85;\n        color: #fff;\n    }\n}\n\n.deploy_section__card_btn--terminal {\n    padding: 4px 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* ── Bottom log pane ── */\n\n.deploy_section__log_pane {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    border-top: 1px solid var(--color-border);\n}\n\n.deploy_section__log_pane_tabs {\n    display: flex;\n    flex-direction: row;\n    flex-shrink: 0;\n    background: var(--color-bg-2);\n    border-bottom: 1px solid var(--color-border);\n    overflow-x: auto;\n    scrollbar-width: none;\n}\n\n.deploy_section__log_pane_tabs::-webkit-scrollbar {\n    display: none;\n}\n\n.deploy_section__log_pane_body {\n    position: relative;\n    flex: 1;\n    overflow: hidden;\n}\n\n.deploy_section__log_modifiers {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 18px;\n    z-index: 10;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-top: 8px;\n    gap: 1px;\n    pointer-events: none;\n}\n\n.deploy_section__log_modifier_btn {\n    pointer-events: auto;\n    width: 18px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    line-height: 1;\n    cursor: pointer;\n    color: var(--color-terminal-text);\n    opacity: 0.6;\n    border-radius: 2px;\n    border: none;\n    background: none;\n    padding: 0;\n    transition: color 0.12s, background-color 0.12s;\n    user-select: none;\n}\n\n@media (pointer: fine) {\n    .deploy_section__log_modifier_btn:hover {\n        color: var(--color-terminal-text);\n        opacity: 1;\n        background-color: rgba(255, 255, 255, 0.1);\n    }\n}\n\n.deploy_section__log_modifier_btn--active {\n    color: var(--color-accent, #3498db);\n}\n\n.deploy_section__log_pane_tab {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    padding: 0 12px;\n    height: 34px;\n    background: none;\n    border: none;\n    border-bottom: 2px solid transparent;\n    color: var(--color-text-muted);\n    font-size: 12px;\n    cursor: pointer;\n    white-space: nowrap;\n    user-select: none;\n    transition: color 0.1s, border-color 0.1s;\n    gap: 6px;\n}\n\n@media (pointer: fine) {\n    .deploy_section__log_pane_tab:hover {\n        color: var(--color-text);\n        background: var(--color-bg-3, rgba(255,255,255,0.04));\n    }\n}\n\n.deploy_section__log_pane_tab.active {\n    color: var(--color-text);\n    border-bottom-color: var(--color-accent, #4a6cf7);\n}\n\n.deploy_section__log_pane_tab_label {\n    flex: 1;\n}\n\n.deploy_section__log_pane_tab_close {\n    width: 14px;\n    height: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 2px;\n    font-size: 15px;\n    line-height: 1;\n    opacity: 0.6;\n    transition: opacity 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__log_pane_tab_close:hover {\n        opacity: 1 !important;\n        background-color: var(--color-bg-3, rgba(255,255,255,0.08));\n    }\n}\n\n.deploy_section__log_pane_viewport {\n    position: absolute;\n    inset: 0;\n    background: var(--color-terminal-bg);\n}\n\n/* Virtuoso scroller root. Vertical padding comes from its Header/Footer\n   spacers; overflow-y is set inline by Virtuoso. */\n.deploy_section__log_pane_content {\n    height: 100%;\n    overflow-x: auto;\n    padding: 0 12px 0 24px;\n    scrollbar-width: thin;\n    box-sizing: border-box;\n}\n\n.deploy_section__log_pane_empty {\n    font-size: 12px;\n    color: var(--color-terminal-text);\n    opacity: 0.6;\n    padding: 8px 0;\n}\n\n/* ── Shared: log lines ── */\n\n.deploy_section__log_line {\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: inherit;\n    line-height: 1.6;\n    color: var(--color-terminal-text);\n    white-space: pre;\n    /* Grow past the viewport so wide TUI output scrolls horizontally, but\n       still fill it so short lines span the full row. */\n    width: max-content;\n    min-width: 100%;\n}\n\n.deploy_section__log_pane_content--wrap .deploy_section__log_line {\n    white-space: pre-wrap;\n    word-break: break-all;\n    width: auto;\n    min-width: 0;\n}\n\n.deploy_section__log_line--cursor {\n    color: var(--color-accent, #4a6cf7);\n    animation: deploy_cursor_blink 1s step-end infinite;\n}\n\n@keyframes deploy_cursor_blink {\n    0%, 100% { opacity: 1; }\n    50%       { opacity: 0; }\n}\n\n/* ── Error banner ── */\n\n.deploy_section__error_banner {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    margin: 24px 16px;\n    padding: 14px 16px;\n    border-radius: 6px;\n    background: color-mix(in srgb, var(--color-danger, #e53e3e) 10%, transparent);\n    border: 1px solid color-mix(in srgb, var(--color-danger, #e53e3e) 35%, transparent);\n    color: var(--color-danger, #e53e3e);\n    font-size: 13px;\n    font-family: monospace;\n    line-height: 1.6;\n    word-break: break-all;\n}\n\n.deploy_section__error_banner--clickable {\n    cursor: pointer;\n    user-select: none;\n}\n\n.deploy_section__error_banner--clickable:hover {\n    background: color-mix(in srgb, var(--color-danger, #e53e3e) 15%, transparent);\n}\n\n.deploy_section__error_banner_body {\n    flex: 1;\n    min-width: 0;\n}\n\n.deploy_section__error_banner_summary {\n    white-space: pre-wrap;\n}\n\n.deploy_section__error_banner_toggle {\n    opacity: 0.7;\n    font-size: 11px;\n}\n\n.deploy_section__error_banner_detail {\n    margin: 10px 0 0;\n    padding: 10px;\n    background: color-mix(in srgb, var(--color-danger, #e53e3e) 8%, transparent);\n    border-radius: 4px;\n    font-size: 12px;\n    white-space: pre-wrap;\n    word-break: break-all;\n    overflow-x: auto;\n}\n\n.deploy_section__error_banner_icon {\n    flex-shrink: 0;\n    font-size: 15px;\n    font-family: sans-serif;\n    margin-top: 1px;\n}\n\n/* ── Empty state ── */\n\n.deploy_section__empty {\n    text-align: center;\n    color: var(--color-text-muted);\n    padding: 48px 0;\n    font-size: 14px;\n}\n\n/* ── Mobile layout ── */\n\n/* Mobile uses the same flex-column tab layout as desktop — no overrides needed\n   beyond cosmetic tweaks like smaller tab hit areas on narrow screens. */\n.deploy_section--mobile .deploy_section__tab {\n    padding: 6px 12px;\n}\n\n.deploy_section__tab_content {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n\n/* Accordion section: padding inside each accordion item */\n.deploy_section__accordion_section {\n    padding: 12px 4px;\n}\n\n/* Mobile log pane inside accordion: fill the accordion content area */\n.deploy_section__log_pane--accordion {\n    height: 100%;\n    border-top: none;\n}\n\n/* Mobile env tabs */\n\n.deploy_section__env_tabs {\n    display: flex;\n    gap: 4px;\n}\n\n.deploy_section__env_tab {\n    padding: 5px 14px;\n    border-radius: 6px;\n    border: 1px solid var(--color-border, #333);\n    background: transparent;\n    color: var(--color-text-muted);\n    font-size: 13px;\n    cursor: pointer;\n    transition: background 0.1s, color 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__env_tab:hover {\n        background: var(--color-bg-hover, rgba(255,255,255,0.06));\n        color: var(--color-text, #fff);\n    }\n}\n\n.deploy_section__env_tab.active {\n    background: var(--color-accent, #4a6cf7);\n    border-color: var(--color-accent, #4a6cf7);\n    color: #fff;\n}\n\n/* Mobile service list */\n\n.deploy_section__service_list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.deploy_section__service_row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 14px;\n    border-radius: 8px;\n    background: var(--color-bg-secondary, rgba(255,255,255,0.04));\n    border: 1px solid var(--color-border, #333);\n}\n\n.deploy_section__service_name {\n    font-size: 13px;\n    color: var(--color-text, #fff);\n}\n\n.deploy_section__service_status {\n    font-size: 12px;\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-weight: 500;\n    background: var(--color-bg-hover, rgba(255,255,255,0.08));\n    color: var(--color-text-muted);\n}\n\n.deploy_section__service_status--running,\n.deploy_section__service_status--up {\n    background: rgba(34, 197, 94, 0.15);\n    color: #22c55e;\n}\n\n.deploy_section__service_status--stopped,\n.deploy_section__service_status--exited,\n.deploy_section__service_status--down {\n    background: rgba(239, 68, 68, 0.15);\n    color: #ef4444;\n}\n\n.deploy_section__service_status--starting,\n.deploy_section__service_status--restarting {\n    background: rgba(234, 179, 8, 0.15);\n    color: #eab308;\n}\n\n/* Mobile deploy buttons */\n\n.deploy_section__deploy_btns {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.deploy_section__deploy_btn {\n    padding: 7px 18px;\n    border-radius: 6px;\n    border: 1px solid var(--color-accent, #4a6cf7);\n    background: var(--color-accent, #4a6cf7);\n    color: #fff;\n    font-size: 13px;\n    cursor: pointer;\n    transition: opacity 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__deploy_btn:hover:not(:disabled) {\n        opacity: 0.85;\n    }\n}\n\n.deploy_section__deploy_btn:disabled {\n    opacity: 0.4;\n    cursor: default;\n}\n\n.deploy_section__deploy_btn--running {\n    opacity: 0.7;\n}\n\n/* Mobile custom service row */\n\n.deploy_section__custom_row {\n    display: flex;\n    gap: 8px;\n}\n\n.deploy_section__custom_input {\n    flex: 1;\n    padding: 7px 12px;\n    border-radius: 6px;\n    border: 1px solid var(--color-border, #333);\n    background: var(--color-bg-secondary, rgba(255,255,255,0.04));\n    color: var(--color-text, #fff);\n    font-size: 13px;\n    outline: none;\n    transition: border-color 0.1s;\n}\n\n.deploy_section__custom_input:focus {\n    border-color: var(--color-accent, #4a6cf7);\n}\n\n.deploy_section__custom_input::placeholder {\n    color: var(--color-text-muted);\n}\n\n/* Mobile proxy row */\n\n.deploy_section__proxy_row {\n    display: flex;\n    gap: 8px;\n}\n\n.deploy_section__proxy_port_input {\n    flex: 1;\n    padding: 7px 12px;\n    border-radius: 6px;\n    border: 1px solid var(--color-border, #333);\n    background: var(--color-bg-secondary, rgba(255,255,255,0.04));\n    color: var(--color-text, #fff);\n    font-size: 13px;\n    outline: none;\n    transition: border-color 0.1s;\n}\n\n.deploy_section__proxy_port_input:focus {\n    border-color: var(--color-accent, #4a6cf7);\n}\n\n.deploy_section__proxy_port_input::placeholder {\n    color: var(--color-text-muted);\n}\n\n/* Sessions list */\n\n.deploy_section__sessions {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.deploy_section__session_row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 7px 10px;\n    border-radius: 6px;\n    border: 1px solid var(--color-border, #333);\n    background: var(--color-bg-secondary, rgba(255,255,255,0.04));\n}\n\n.deploy_section__session_label {\n    font-size: 12px;\n    color: var(--color-text-muted);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1;\n    min-width: 0;\n}\n\n.deploy_section__session_loading {\n    font-size: 11px;\n    color: var(--color-text-muted);\n    flex-shrink: 0;\n}\n\n.deploy_section__session_actions {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    flex-shrink: 0;\n}\n\n.deploy_section__session_btn {\n    padding: 3px 10px;\n    border-radius: 4px;\n    border: 1px solid var(--color-border, #333);\n    background: transparent;\n    color: var(--color-text-muted);\n    font-size: 11px;\n    cursor: pointer;\n    transition: color 0.1s, border-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__session_btn:hover {\n        color: var(--color-text);\n        border-color: var(--color-accent, #4a6cf7);\n    }\n}\n\n.deploy_section__session_btn--close {\n    padding: 3px 7px;\n}\n\n/* Mobile log panel */\n\n.deploy_section__log_panel {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    border: 1px solid var(--color-border, #333);\n    border-radius: 6px;\n    overflow: hidden;\n}\n\n.deploy_section__log_header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 7px 12px;\n    background: var(--color-bg, #1a1a1a);\n    border-bottom: 1px solid var(--color-border, #333);\n}\n\n.deploy_section__log_title {\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--color-text-muted);\n}\n\n.deploy_section__log_clear {\n    background: none;\n    border: none;\n    font-size: 11px;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    padding: 0 4px;\n    opacity: 0.7;\n    transition: opacity 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__log_clear:hover {\n        opacity: 1;\n    }\n}\n\n.deploy_section__log_stop {\n    background: none;\n    border: 1px solid var(--color-danger, #e53e3e);\n    border-radius: 3px;\n    font-size: 11px;\n    color: var(--color-danger, #e53e3e);\n    cursor: pointer;\n    padding: 1px 6px;\n    opacity: 0.85;\n    transition: opacity 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__log_stop:hover {\n        opacity: 1;\n    }\n}\n\n.deploy_section__log_body {\n    max-height: 280px;\n    overflow-y: auto;\n    padding: 8px 12px;\n    background: var(--color-bg-2, #111);\n    scrollbar-width: thin;\n}\n\n/* ── Desktop inline browser tab panel ── */\n\n.deploy_section__browser_panel {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    overflow: hidden;\n}\n\n.deploy_section__browser_tabs_bar {\n    display: flex;\n    flex-direction: row;\n    flex-shrink: 0;\n    background-color: var(--color-bg-2);\n    border-bottom: 1px solid var(--color-border);\n    overflow-x: auto;\n    scrollbar-width: none;\n    touch-action: pan-x;\n}\n\n.deploy_section__browser_tabs_bar::-webkit-scrollbar {\n    display: none;\n}\n\n.deploy_section__browser_tab {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    padding: 0 18px;\n    height: 38px;\n    background: none;\n    border: none;\n    border-bottom: 2px solid transparent;\n    color: var(--color-text-muted);\n    font-size: 13px;\n    cursor: pointer;\n    white-space: nowrap;\n    user-select: none;\n    gap: 7px;\n    transition: color 0.1s, border-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__browser_tab:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n.deploy_section__browser_tab.active {\n    color: var(--color-text);\n    border-bottom-color: var(--color-accent);\n}\n\n.deploy_section__browser_tab_label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 140px;\n}\n\n.deploy_section__browser_tab_close {\n    flex-shrink: 0;\n    width: 15px;\n    height: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 2px;\n    font-size: 15px;\n    line-height: 1;\n    opacity: 0;\n    transition: opacity 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__browser_tab:hover .deploy_section__browser_tab_close,\n    .deploy_section__browser_tab.active .deploy_section__browser_tab_close {\n        opacity: 0.6;\n    }\n\n    .deploy_section__browser_tab_close:hover {\n        opacity: 1 !important;\n        background-color: var(--color-bg-3);\n    }\n}\n\n@media (pointer: coarse) {\n    .deploy_section__browser_tab_close {\n        opacity: 0.7;\n    }\n}\n\n.deploy_section__browser_new_tab_btn {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 38px;\n    height: 38px;\n    background: none;\n    border: none;\n    color: var(--color-text-muted);\n    font-size: 20px;\n    line-height: 1;\n    cursor: pointer;\n    transition: color 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__browser_new_tab_btn:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n/* Relative container so BrowserStreamModal (position:absolute) fills this area */\n.deploy_section__browser_content {\n    position: relative;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.deploy_section__browser_empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n}\n\n/* ── Desktop inline terminal tab panel ── */\n\n.deploy_section__terminal_panel {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    overflow: hidden;\n}\n\n.deploy_section__terminal_tabs_bar {\n    display: flex;\n    flex-direction: row;\n    flex-shrink: 0;\n    background-color: var(--color-bg-2);\n    border-bottom: 1px solid var(--color-border);\n    overflow-x: auto;\n    scrollbar-width: none;\n    touch-action: pan-x;\n}\n\n.deploy_section__terminal_tabs_bar::-webkit-scrollbar {\n    display: none;\n}\n\n.deploy_section__terminal_tab {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    padding: 0 18px;\n    height: 38px;\n    background: none;\n    border: none;\n    border-bottom: 2px solid transparent;\n    color: var(--color-text-muted);\n    font-size: 13px;\n    cursor: pointer;\n    white-space: nowrap;\n    user-select: none;\n    gap: 7px;\n    transition: color 0.1s, border-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__terminal_tab:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n.deploy_section__terminal_tab.active {\n    color: var(--color-text);\n    border-bottom-color: var(--color-accent);\n}\n\n.deploy_section__terminal_tab_label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 140px;\n}\n\n.deploy_section__terminal_tab_close {\n    flex-shrink: 0;\n    width: 15px;\n    height: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 2px;\n    font-size: 15px;\n    line-height: 1;\n    opacity: 0;\n    transition: opacity 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__terminal_tab:hover .deploy_section__terminal_tab_close,\n    .deploy_section__terminal_tab.active .deploy_section__terminal_tab_close {\n        opacity: 0.6;\n    }\n\n    .deploy_section__terminal_tab_close:hover {\n        opacity: 1 !important;\n        background-color: var(--color-bg-3);\n    }\n}\n\n@media (pointer: coarse) {\n    .deploy_section__terminal_tab_close {\n        opacity: 0.7;\n    }\n}\n\n.deploy_section__terminal_new_tab_btn {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 38px;\n    height: 38px;\n    background: none;\n    border: none;\n    color: var(--color-text-muted);\n    font-size: 20px;\n    line-height: 1;\n    cursor: pointer;\n    transition: color 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__terminal_new_tab_btn:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n.deploy_section__terminal_new_tab_wrapper {\n    position: relative;\n    flex-shrink: 0;\n}\n\n.deploy_section__terminal_new_selector {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    z-index: 100;\n    min-width: 160px;\n    background: var(--color-bg-2, #1a1a2e);\n    border: 1px solid var(--color-border);\n    border-radius: 6px;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.3);\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.deploy_section__terminal_new_selector_title {\n    padding: 6px 12px;\n    font-size: 11px;\n    color: var(--color-text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    border-bottom: 1px solid var(--color-border);\n}\n\n.deploy_section__terminal_new_selector_item {\n    background: none;\n    border: none;\n    text-align: left;\n    padding: 8px 12px;\n    font-size: 13px;\n    color: var(--color-text);\n    cursor: pointer;\n    transition: background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__terminal_new_selector_item:hover {\n        background-color: var(--color-bg-3);\n    }\n}\n\n/* Relative container so TerminalModal (position:absolute) fills this area */\n.deploy_section__terminal_content {\n    position: relative;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.deploy_section__terminal_empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n}\n\n/* ── New Terminal Modal ──────────────────────────────────────────────────── */\n\n.deploy_section__new_terminal_modal_backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 1100;\n    background: rgba(0, 0, 0, 0.55);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.deploy_section__new_terminal_modal {\n    background: var(--color-bg-2, #1a1a2e);\n    border: 1px solid var(--color-border);\n    border-radius: 10px;\n    padding: 20px;\n    min-width: 300px;\n    max-width: 440px;\n    width: 90%;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.deploy_section__new_terminal_modal_title {\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--color-text);\n}\n\n.deploy_section__new_terminal_modal_section {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.deploy_section__new_terminal_modal_label {\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: var(--color-text-muted);\n}\n\n.deploy_section__new_terminal_modal_services {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    max-height: 200px;\n    overflow-y: auto;\n}\n\n.deploy_section__new_terminal_modal_service {\n    background: none;\n    border: 1px solid var(--color-border);\n    border-radius: 6px;\n    text-align: left;\n    padding: 8px 12px;\n    font-size: 13px;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    transition: background 0.1s, color 0.1s, border-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__new_terminal_modal_service:hover {\n        background: var(--color-bg-hover, rgba(255,255,255,0.06));\n        color: var(--color-text);\n    }\n}\n\n.deploy_section__new_terminal_modal_service.active {\n    background: var(--color-accent, #4a6cf7);\n    border-color: var(--color-accent, #4a6cf7);\n    color: #fff;\n}\n\n.deploy_section__new_terminal_modal_actions {\n    display: flex;\n    gap: 8px;\n    justify-content: flex-end;\n}\n\n.deploy_section__new_terminal_modal_cancel {\n    padding: 7px 18px;\n    border-radius: 6px;\n    border: 1px solid var(--color-border);\n    background: transparent;\n    color: var(--color-text-muted);\n    font-size: 13px;\n    cursor: pointer;\n    transition: background 0.1s, color 0.1s;\n}\n\n@media (pointer: fine) {\n    .deploy_section__new_terminal_modal_cancel:hover {\n        background: var(--color-bg-hover, rgba(255,255,255,0.06));\n        color: var(--color-text);\n    }\n}\n\n/* ── Mobile inline override ──────────────────────────────────────────────────\n   On pointer:coarse (touch), .proxy_modal and .terminal_modal default to\n   position:fixed (full viewport). Override to position:absolute so they fill\n   the inline container instead. Scoped tightly — only inside our containers.\n   To restore old mobile floating behavior: remove these two rules.            */\n\n@media (pointer: coarse) {\n    .deploy_section__browser_content .proxy_modal {\n        position: absolute;\n    }\n\n    .deploy_section__terminal_content .terminal_modal {\n        position: absolute;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
